import React from "react";
import { Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { FiMapPin, FiMail, FiClock } from "react-icons/fi";
import patternImage from "../image/landing/designer/bg-patterns.webp";
import "./ContactUs.css";

const ContactUs = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    console.log("Form submitted:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Form submission failed:", errorInfo);
  };

  return (
    <section
      className="contact-us-section"
      style={{ "--contact-pattern-image": `url(${patternImage})` }}
    >
      <div className="contact-us-content">
        <div className="contact-eyebrow">Talk to TattQR</div>
        <h2 className="contact-section-head">Let Us Build Your Story Link</h2>
        <p className="contact-section-text">
          Ready to turn ink into an experience? Share your concept and our team
          will guide you from QR strategy to final scan-ready delivery.
        </p>

        <div className="contact-points">
          <div className="contact-point">
            <span className="contact-icon">
              <FiMapPin />
            </span>
            CA, USA
          </div>
          <div className="contact-point">
            <span className="contact-icon">
              <FiMail />
            </span>
            tattqr@gmail.com
          </div>
          <div className="contact-point">
            <span className="contact-icon">
              <FiClock />
            </span>
            24/7 scan support for active clients
          </div>
        </div>

        <button
          type="button"
          className="contact-cta"
          onClick={() => navigate("/signup")}
        >
          Design My QR
        </button>
      </div>

      <div className="contact-us-form contact-card">
        <Form
          form={form}
          name="contact-us"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Name"
            name="name"
            className="form-item"
            rules={[{ required: true, message: "Please enter your name!" }]}
          >
            <Input placeholder="Enter your name" className="form-input" />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            className="form-item"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email address!" },
            ]}
          >
            <Input placeholder="Enter your email" className="form-input" />
          </Form.Item>

          <Form.Item
            label="Subject"
            name="subject"
            className="form-item"
            rules={[{ required: true, message: "Please enter a subject!" }]}
          >
            <Input placeholder="Subject" className="form-input" />
          </Form.Item>

          <Form.Item
            label="Message"
            name="message"
            className="form-item"
            rules={[{ required: true, message: "Please enter your message!" }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Tell us about your tattoo idea"
              className="form-input textarea"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block className="submit-button">
              Send Message
            </Button>
          </Form.Item>
        </Form>
      </div>
    </section>
  );
};

export default ContactUs;
